/** Reserved `weight_scheme` value for org-team custom rubric weights. */
export const ORG_TEAM_RUBRIC_CUSTOM_SCHEME_ID = '__org_custom__';

export const ORG_TEAM_RUBRIC_CUSTOM_SCHEME_LABEL = 'Custom';

export function isOrgTeamRubricCustomSchemeId(scheme) {
  return String(scheme ?? '').trim() === ORG_TEAM_RUBRIC_CUSTOM_SCHEME_ID;
}
